import { useNavigate } from "react-router-dom"
import { useToggle } from "."
export const useMenu = () => {
    const {state: opened, toggle} = useToggle(false)
    const navigate = useNavigate()

    const ops = {
        redirect: (link: string): void => {
            navigate(link)
            ops.closeMenu()

        },
        redirectExternal: (link: string): void => {
            window.location.replace(link)
            ops.closeMenu()
        },
        openExternal: (link: string): void => {
            window.open(link, "_blank")
            ops.closeMenu()
        },
        openMenu: (): void => toggle(true),
        closeMenu: (): void => {
            if (opened)
                toggle(false)
        }
    }

    return { opened, ...ops }
}